import script from "./estimates-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./estimates-modal.vue?vue&type=script&setup=true&lang=js"

import "./estimates-modal.vue?vue&type=style&index=0&id=685dc229&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685dc229"]])

export default __exports__